import { useContext, useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import {
  MESSAGES,
  USER_COLUMN_LABELS,
  USER_TABLE_COLUMNS,
  ROLE_FIELDS,
  ROLE_FIELDS_CLASSNAME,
  APPROVAL_FIELDS,
  EMPLOYMENT_STATUS_FIELDS,
  COMPANY_FIELDS,
  TITLES,
} from "./constant";
import * as Yup from "yup";
import { getAllUsers,resetPasswordByHR } from "../../Services/UserService";
import toast from "react-hot-toast";
import { CommonTable, Loader, Spinner, PinInput} from "../../Components/Common";
import { RESET_PAGINATION, ROLES } from "../../Constants/Strings";
import { getUniqueDataById } from "../../Utils";
import InfiniteScroll from "react-infinite-scroll-component";
import { FiEdit, FiFilter, FiInfo } from "react-icons/fi";
import { MdLockReset } from 'react-icons/md';
import { extractErrorMessage } from "../../Utils/extractErrorMessage";
import * as route from "../../routes";
import { Form, Formik } from "formik";
import SearchableDropdown from "../../Components/Common/SearchableDropdown";
import { UserContext } from "../../Context";

const UserListPage = () => {
  const [userData, setUserData] = useState([]);
  const [loading, setLoading] = useState(false);
  const [pagination, setPagination] = useState(RESET_PAGINATION);
  const [showFilter, setShowFilter] = useState(false);
  const [selectedUser, setSelectedUser] = useState(null);
  const { user } = useContext(UserContext);
  const [showModal, setShowModal] = useState(false);
  const [resetUser, setResetUser] = useState(null);
  const [filterFields, setFilterFields] = useState({
    is_approved: "",
    role: "",
    employment_status: "",
    user_id: "",
  });
  const navigate = useNavigate();
  const getPaginationData = () => {
    if (pagination.offset >= pagination.count) return;
    const finalParams = { ...pagination, ...filterFields };
    fetchUsers(finalParams);
  };

  const initialValues = {
    confirmPassword: "",
    newPassword: "",
  };

  const validationSchema = Yup.object().shape({
    newPassword: Yup.string()
    .matches(/^[0-9]+$/, "Only digits are allowed")
    .length(4, "Password must be exactly 4 digits")
    .required("Required"),

  confirmPassword: Yup.string()
    .matches(/^[0-9]+$/, "Only digits are allowed")
    .length(4, "Password must be exactly 4 digits")
    .oneOf([Yup.ref("newPassword"), null], "Passwords must match")
    .required("Required"),
  });
  
  const handleResetPassword = async (row, values) => {
  const data = {
    id: row.id,
    new_password: values.newPassword,
    confirm_password: values.confirmPassword
  };

    try {
    const response = await resetPasswordByHR(data);

    if (response?.status === 200) {
      toast.success(MESSAGES.PASSWORD_RESET_SUCCESS);
    } else {
      const msg = extractErrorMessage(response) || MESSAGES.PASSWORD_RESET_FAILDED;
      toast.error(msg);
    }

    setShowModal(false);
    setResetUser(null);

  } catch (error) {
    toast.error(
      extractErrorMessage(error) || MESSAGES.PASSWORD_RESET_FAILDED
    );
    setShowModal(false);
    setResetUser(null);
  }
};

  const fetchUserOptions = async (searchText) => {
    // ✅ FIX: extract string correctly
    const query =
      typeof searchText === "string" ? searchText : searchText?.search || "";

    const params = {
      ...RESET_PAGINATION,
      search: query || "",
    };

    if (query.trim()) {
      params.search = query;
    }

    const response = await getAllUsers(params);

    return response.data.results;
  };

  const fetchUsers = async (finalParams, isInitial = false) => {
    setLoading(true);
    try {
      const response = await getAllUsers({ ...finalParams });
      if (response.status === 200) {
        if (isInitial) {
          setUserData(response.data.results);
        } else {
          setUserData((prevData) =>
            getUniqueDataById(prevData, response.data.results),
          );
        }
        setPagination((prevData) => ({
          ...prevData,
          count: response.data.count,
          offset: prevData.offset + prevData.limit,
        }));
      } else {
        const msg = extractErrorMessage(response) || MESSAGES.USER_DATA_ERROR;
        toast.error(msg);
      }
    } catch (error) {
      const msg = extractErrorMessage(error) || MESSAGES.USER_DATA_ERROR;
      toast.error(msg);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchUsers({ ...RESET_PAGINATION }, true);
  }, []);

  const actionFunction = (row) => {
    return (
      <div className="flex items-center gap-4">
        <FiInfo
          size={18}
          title="View User"
          className="text-blue-700 cursor-pointer"
          onClick={() => {
            navigate(route.VIEW_USER.replace(":userId", row.id));
          }}
        />
        <FiEdit
          size={16}
          title="Edit User"
          className="text-primary cursor-pointer"
          onClick={() => {
            navigate(route.EDIT_USER.replace(":userId", row.id));
          }}
        />
        {(user.role === ROLES.HR || user.role === ROLES.DIRECTOR_MANAGEMENT.toUpperCase()) && <div className="cursor-pointer" onClick={() => {
            setResetUser({
              id:row.id,
              full_name:row.full_name,
              first_name:row.first_name,
              last_name:row.last_name,
              role:row.role,
              email:row.email,
              mobile:row.mobile
            });
            setShowModal(true);
          }}><MdLockReset size={20}  title="Reset User Password"/></div>}
      </div>
    );
  };

  const renderField = (key, row) => {
    switch (key) {
      case "is_approved":
        return (
          <div>
            {row.is_approved === false ? (
              <div>Not Approved</div>
            ) : (
              <div>Approved</div>
            )}
          </div>
        );

      case "employment_status":
        return (
          <div>
            {EMPLOYMENT_STATUS_FIELDS.find((f) => f.value === row.employment_status)
              ?.label || "Pending Onboarding"}
          </div>
        );

      case "company":
        return (
          <div>
            {COMPANY_FIELDS.find((f) => f.value === row.company)?.label || "-"}
          </div>
        );

      case "actions":
        return actionFunction(row);

      case "role":
        return (
          <div>
            {ROLE_FIELDS.map(
              (field, index) =>
                row.role === field.value && (
                  <div key={index}>{field.label}</div>
                ),
            )}
          </div>
        );

      default:
        return row[key];
    }
  };

  return (
    <div className="px-4 py-4">
      <div className="flex justify-between items-center mb-4">
        <h2 className="text-xl font-semibold text-primary">
          {TITLES.USER_PAGE_TITLE}
        </h2>

        <div>
          {/*Show Reset Password Popup*/}
          {showModal && (
            <div className="inset-0 z-50 bg-black bg-opacity-40 flex items-center justify-center absolute" onClick={() => {
                  setShowModal(false);
                  setResetUser(null);
                }}>
              <div onClick={(e) => e.stopPropagation()} className="bg-white w-full max-w-md mx-4 rounded-2xl shadow-xl p-6">
                <h2 className="text-lg text-center font-semibold text-primary">
                  Reset Password
                </h2>
                <div className="text-center text-gray-600 mb-6">
                  Resetting password for{" "}
                  <span className="font-semibold text-blue-700">
                    {resetUser?.full_name?.trim()
                      ? resetUser.full_name
                      : `${resetUser?.first_name || ""} ${resetUser?.last_name || ""}`.trim() || "----  ----"}
                  </span>
                </div>
                <div className="w-full">
                    <Formik
                      initialValues={initialValues}
                      validationSchema={validationSchema}
                      onSubmit={(values) => {
                        handleResetPassword(resetUser, values);
                      }}
                    >
                      {({ isSubmitting }) => (
                        <Form className="space-y-3 w-full">
                          <div className="flex flex-col md:gap-3 w-full">
        
                            <div className="flex flex-col md:flex-row gap-3">
                              <div className="w-full md:w-1/2">
                                <PinInput name="newPassword" label="New Password" />
                              </div>
                              <div className="w-full md:w-1/2">
                                <PinInput
                                  name="confirmPassword"
                                  label="Confirm Password"
                                />
                              </div>
                            </div>
                          </div>
        
                          <div className="flex justify-between items-center">
                            <button
                              type="submit"
                              disabled={isSubmitting}
                              className="flex w-full justify-center rounded-md bg-primary mt-4 px-3 py-1.5 text-sm font-semibold leading-6 text-white shadow-sm hover:bg-secondary focus:outline-none"
                            >
                              {!isSubmitting ? "Reset" : <Spinner />}
                            </button>
                          </div>
                        </Form>
                      )}
                    </Formik>
                  </div>
                </div>
              </div>
          )}
        </div>

        <div>
          {/*Show FIlter Popup*/}
          {showFilter && (
            <div className="inset-0 z-50 bg-black bg-opacity-40 flex items-center justify-center absolute">
              <div className="bg-white w-full max-w-md mx-4 rounded-2xl shadow-xl p-6">
                <h2 className="text-lg font-semibold text-primary mb-4">
                  Filter User
                </h2>
                <div className="flex flex-col gap-4">
                  <div className="flex flex-col gap-2">
                    <label className="block text-sm font-medium text-gray-700 mb-1">
                      Users
                    </label>

                    <SearchableDropdown
                      fetchFunction={fetchUserOptions}
                      placeholder="Search user by name"
                      labelKey="full_name"
                      value={selectedUser}
                      includeAllOption={true}
                      onSelect={(selected) => {
                        setSelectedUser(selected);
                        setFilterFields((prev) => ({
                          ...prev,
                          user_id: selected ? selected.id : "",
                        }));
                      }}
                    />
                  </div>

                  <div className="flex flex-col gap-2">
                    <label className="block text-sm font-medium text-gray-700 mb-1">
                      {TITLES.APPROVAL_STATUS}
                    </label>
                    <select
                      value={filterFields.is_approved}
                      name="is_approved"
                      onChange={(e) => {
                        e.preventDefault();
                        setFilterFields((prevData) => ({
                          ...prevData,
                          is_approved: e.target.value,
                        }));
                      }}
                      className="w-full border border-gray-300 rounded-lg px-3 py-2 text-sm focus:ring-1 focus:ring-primary focus:outline-none"
                    >
                      <option value="">All</option>
                      {APPROVAL_FIELDS.map((field) => (
                        <option key={field.value} value={field.value}>
                          {field.label}
                        </option>
                      ))}
                    </select>
                  </div>

                  <div className="flex flex-col gap-2">
                    <label className="block text-sm font-medium text-gray-700 mb-1">
                      {TITLES.EMPLOYMENT_STATUS}
                    </label>
                    <select
                      value={filterFields.employment_status}
                      name="employment_status"
                      onChange={(e) => {
                        e.preventDefault();
                        setFilterFields((prevData) => ({
                          ...prevData,
                          employment_status: e.target.value,
                        }));
                      }}
                      className="w-full border border-gray-300 rounded-lg px-3 py-2 text-sm focus:ring-1 focus:ring-primary focus:outline-none"
                    >
                      <option value="">All</option>
                      {EMPLOYMENT_STATUS_FIELDS.map((field) => (
                        <option key={field.value} value={field.value}>
                          {field.label}
                        </option>
                      ))}
                    </select>
                  </div>

                  <div className="flex flex-col gap-2">
                    <label className="block text-sm font-medium text-gray-700 mb-1">
                      {TITLES.ROLE}
                    </label>
                    <select
                      value={filterFields.role}
                      name="is_approved"
                      onChange={(e) => {
                        e.preventDefault();
                        setFilterFields((prevData) => ({
                          ...prevData,
                          role: e.target.value,
                        }));
                      }}
                      className="w-full border border-gray-300 rounded-lg px-3 py-2 text-sm focus:ring-1 focus:ring-primary focus:outline-none"
                    >
                      <option value="">All</option>
                      {ROLE_FIELDS.map((field) => (
                        <option key={field.value} value={field.value}>
                          {field.label}
                        </option>
                      ))}
                    </select>
                  </div>

                  {/*Filter Buttons*/}
                  <div className="flex justify-between items-center">
                    <button
                      className=" px-4 py-2 rounded-lg bg-gray-200 hover:bg-gray-300 text-gray-800 text-sm"
                      onClick={() => {
                        const cleared = { is_approved: "", role: "" };
                        setFilterFields(cleared);
                        setUserData([]);
                        setSelectedUser(null);
                        setPagination(RESET_PAGINATION); // reset pagination
                        fetchUsers({ ...RESET_PAGINATION, ...cleared }, true);
                      }}
                    >
                      Clear
                    </button>

                    <div className="flex items-center justify-between gap-2">
                      <button
                        className="px-4 py-2 rounded-lg bg-gray-200 hover:bg-gray-300 text-sm text-gray-800"
                        onClick={() => {
                          setShowFilter(false);
                        }}
                      >
                        Cancel
                      </button>

                      <button
                        className="px-4 py-2 rounded-lg bg-primary hover:bg-green-600 text-white text-sm"
                        onClick={() => {
                          const isAllEmpty = Object.values(filterFields).every(
                            (value) => value === "" || value === null,
                          );

                          if (isAllEmpty) {
                            return;
                          }
                          setUserData([]);
                          setPagination(RESET_PAGINATION); // reset pagination
                          fetchUsers(
                            { ...RESET_PAGINATION, ...filterFields },
                            true,
                          );
                          setShowFilter(false);
                        }}
                      >
                        Apply
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          )}
        </div>

        <div className="flex items-center justify-center md-4">
          <button
            className=" px-4 py-2 rounded bg-primary hover:bg-green-600 text-white font-bold  shadow-lg flex items-center justify-between gap-1"
            onClick={() => setShowFilter(!showFilter)}
          >
            <FiFilter className="text-2xl" />
          </button>
        </div>
      </div>
      {loading && userData.length === 0 ? (
        <div className="flex justify-center pt-10">
          <Loader size={4} />
        </div>
      ) : userData.length === 0 ? (
        <div className="text-center text-gray-500 mt-10">
          {MESSAGES.NO_USER_DATA}
        </div>
      ) : (
        <div className="hidden md:block">
          <InfiniteScroll
            dataLength={userData.length}
            next={getPaginationData}
            hasMore={pagination.offset < pagination.count}
            scrollableTarget="scrollDiv"
          >
            <div
              className="h-[70vh] overflow-x-auto overflow-y-auto border rounded-md"
              id="scrollDiv"
            >
              <CommonTable
                tableColumns={USER_TABLE_COLUMNS}
                columnLabels={USER_COLUMN_LABELS}
                tableRows={userData}
                renderField={renderField}
                headerClassName="bg-gray-100"
                rowClick={null}
              />
            </div>
          </InfiniteScroll>
        </div>
      )}

      {/*  MOBILE CARD VIEW */}
      <div className="md:hidden">
        <InfiniteScroll
          dataLength={userData.length}
          next={getPaginationData}
          hasMore={pagination.offset < pagination.count}
          scrollableTarget="mobileUserList"
        >
          <div
            id="mobileUserList"
            className="h-[75vh] overflow-y-auto space-y-2 p-1"
          >
            {userData.map((user) => {
              return (
                <div
                  key={user.id}
                  className="bg-white shadow-md rounded-lg p-2 border border-gray-200 "
                >
                  <div className="flex justify-between m-2">
                    <p className="font-semibold text-primary">
                      {user.first_name} {user.last_name}
                    </p>
                    <p
                      className={`px-1 rounded-md text-sm inline-block ${
                        user.is_approved
                          ? "bg-green-50 text-green-700"
                          : "bg-red-50 text-red-700"
                      }`}
                    >
                      {user.is_approved ? "Approved" : "Not Approved"}
                    </p>
                  </div>
                  <div className="flex justify-between m-2">
                    <p className="text-sm text-gray-600">
                      {COMPANY_FIELDS.find((f) => f.value === user.company)
                        ?.label || "-"}
                    </p>
                  </div>
                  <div className=" flex justify-between m-2">
                    <p>{user.mobile}</p>
                    <p
                      className={`px-1 rounded-md text-sm inline-block ${
                        user.employment_status === "ONBOARDED"
                          ? "bg-green-50 text-green-700"
                          : user.employment_status === "OFFBOARDED"
                          ? "bg-red-50 text-red-700"
                          : "bg-yellow-50 text-yellow-700"
                      }`}
                    >
                      {EMPLOYMENT_STATUS_FIELDS.find(
                        (f) => f.value === user.employment_status,
                      )?.label || "Pending Onboarding"}
                    </p>
                  </div>
                  <div className="flex justify-between m-2">
                    <p
                      className={`${
                        ROLE_FIELDS_CLASSNAME.find(
                          (role) => role.value === user.role,
                        )?.className
                      } px-1 rounded-md text-sm inline-block `}
                    >
                      {ROLE_FIELDS.find((role) => role.value === user.role)
                        ?.label || "N/A"}
                    </p>
                    <div className="">{actionFunction(user)}</div>
                  </div>
                </div>
              );
            })}
          </div>
        </InfiniteScroll>
      </div>
    </div>
  );
};

export default UserListPage;
